export default __webpack_public_path__ + "static/media/FromPortlandToPortland.38d204a8.JPG";